import type { PaymentType } from '../enums/PaymentType'

export class OrderPaymentTypeEntity {
  id?: number
  paymentType?: PaymentType
  enabled?: boolean
  feePercentage?: number
  minimumFee?: number
  minimumAppVersion?: string | null
}
